import React from "react";

const Trash = (props) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width}
        height={props.height}
        viewBox="0 0 12.739 14.559"
      >
        <path
          id={props.id}
          data-name="Icon awesome-trash"
          d="M12.284.91H8.872L8.6.378A.682.682,0,0,0,7.993,0H4.743a.675.675,0,0,0-.609.378L3.867.91H.455A.455.455,0,0,0,0,1.365v.91a.455.455,0,0,0,.455.455H12.284a.455.455,0,0,0,.455-.455v-.91A.455.455,0,0,0,12.284.91ZM1.513,13.28a1.365,1.365,0,0,0,1.362,1.28h6.99a1.365,1.365,0,0,0,1.362-1.279l.6-9.64H.91Z"
          transform="translate(0 0)"
          fill={props.fill}
        />
      </svg>
    </>
  );
};

export default Trash;
